export class Class {
  id: number;
  dataset_id: number;
  name: string;
  description: string;
  services: string;
}
